import React, { useState } from 'react';
import classnames from 'classnames';
import SharedDndProvider from 'components/DragDropContext/SharedDndProvider';
import Modal, {
  Header,
  Title,
  Body,
  Footer,
} from '@aha-app/react-bootstrap-modal';
import styles from 'components/Dashboards/Dashboards.module.css';
import PanelConfiguration from 'components/Dashboards/components/PanelConfiguration';
import Immutable from 'immutable';
import { Panel } from 'components/Dashboards/store/records';
import { DASHBOARD_PANEL_CONTEXT_NOTE } from 'components/Dashboards/constants';

function EditPanelModal({ open, panel, updatePanel, closePanelModal }) {
  const [editingPanel, updateEditingPanel] = useState(
    new Panel(Immutable.fromJS(panel))
  );

  return (
    <SharedDndProvider>
      <Modal
        show={open}
        onHide={closePanelModal}
        className={classnames(styles.Modal, 'modal-big')}
        dialogClassName={styles.ModalDialogFix}
        backdrop={'static'}
      >
        <Header closeButton>
          <Title id='ModalHeader' className={styles.ModalTitle}>
            Edit panel
          </Title>
        </Header>
        <Body className={styles.ModalBody}>
          <PanelConfiguration
            panel={editingPanel}
            updatePanel={updateEditingPanel}
            context={DASHBOARD_PANEL_CONTEXT_NOTE}
          />
        </Body>
        <Footer>
          <button
            className={classnames('btn', 'btn-primary', {})}
            onClick={() => {
              updatePanel(editingPanel.id, editingPanel.toJS());
              closePanelModal();
            }}
          >
            Update
          </button>
        </Footer>
      </Modal>
    </SharedDndProvider>
  );
}

export default EditPanelModal;
